import AfterLoginGuard from "../../guards/AfterLoginGuard";
import ExternalRedirect from "./ExternalRedirect";
import Home from "./Home";

const eLearningRoutes = [
  {
    path: "/e-learning",
    element: <ExternalRedirect />,
    children: [{ path: "", element: <Home /> }],
  },
];

export default eLearningRoutes;
